// This address points to a dummy ERC-20 contract. Replace it with your own smart contracts.
const addresses = {
  erc721: "0x61681514eA040d19dC4279301aDC10bf654D886A",
};
export default addresses;
